import type { ReportContent } from './types';

interface ReportSaveState {
  title: string;
  content: ReportContent;
}

export function readReportSaveState(
  serialized: string,
  fallback: ReportSaveState
): ReportSaveState {
  try {
    const parsed = JSON.parse(serialized) as { title?: unknown; content?: unknown };
    if (typeof parsed.title === 'string' && parsed.content && typeof parsed.content === 'object') {
      return { title: parsed.title, content: parsed.content as ReportContent };
    }
  } catch {
    // The in-memory current state is the safest fallback before the first accepted save.
  }
  return fallback;
}

export function markReportContentSaved(
  serialized: string,
  content: ReportContent,
  fallbackTitle: string
): string {
  const saved = readReportSaveState(serialized, { title: fallbackTitle, content });
  return JSON.stringify({ title: saved.title, content });
}
